import React from "react";
import Routes from "./Components/Routes/Routes";
import './App.css'

function App() {
  return (
    <div className="container-fluid">
      <Routes />
    </div>
  );
}

export default App;
